<template>
    <a-card>
    <h3 style="text-align: center;margin:20px 0 40px">相关附件</h3>
    <FileUpload v-model:value="form.annexAddress" :showBtn="false" disabled />
    </a-card>
</template>

<script>

    import { projectAnnex } from "@/api/TechnologieprojekteApply";
    import {
        formMixin
    } from "@/mixins";
    export default {
        name: "相关附件",
        mixins: [formMixin],
        components: {
        },
        data() {
            return {
                options: null,
                form:{
                },
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectAnnex.detailByProject,
                    params: { 
                        projectId: this.$route.query.projectId,
                        classification: this.$route.query.classification,
                     }
                }).then((res) => {
                    if(res){
                        this.form = res
                    }
                });
            }
        }

    }
</script>
